import { vars } from "@app/styles";
import styled from "styled-components";

export const Container = styled.div<{ hasSystemMessage?: boolean }>`
  animation: smoothLoading 1s;
  background-color: ${vars.colorNavDark};
  height: ${({ hasSystemMessage }) => (hasSystemMessage ? "calc(100vh - 40px)" : "100vh")};
  width: ${vars.spacingNavWidth};
  color: ${vars.colorWhite};
`;

export const Nav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  gap: 0.25rem;
  padding-block: 1rem;
`;

export const TopNav = styled.div`
  flex: 1;
`;
